module.exports = __webpack_public_path__ + "img/vbdata.8e0028e5.png";